// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationCollectionsPath = 'M41.949 22l-9-9H7v74h74.951l18.546-51H83V22H41.949zm-8.07 21h56.623L77.047 80H19.251l14.628-37zm-3.828-23H14v54.244L29.12 36H76v-7H39.05l-8.999-9zM68 58v-7H50v7h18z';
var IllustrationCollections = baseIllustration('IllustrationCollections', {
  getPath: () => IllustrationCollectionsPath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationCollections;
//# sourceMappingURL=index.js.map